// --------------------------------------------------------
// LabelInput - LabelInput
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import { CardPhoto, SCardUploadPhoto } from "./CardUploadPhoto.style";
import { ReactComponent as Upload } from "../../assets/imgs/upload.svg";
import { H3 } from "../UI/generalLayout/Layout.styled";
import CardEditPhoto from "../cardEditPhoto/CardEditPhoto";
import imageNotPermission from "../../assets/imgs/tipos_imagem_not_permission.png";
import tamanhoImagemNotPermission from "../../assets/imgs/tamanho_not_permission.png";

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// LabelInput INTERFACE
// --------------------------------------------------------

interface ICardUploadPhoto {
  onChange: (e: any) => void;
  preview: string;
  selectedFile: any;
  imageNotAllowedBySize: boolean;
  imageNotAllowedByExtension: boolean;
}

/**
/**
 * A component that renders a input field with a label and placeholders.
 *

 */
const CardUploadPhoto = ({
  preview,
  selectedFile,
  onChange,
  imageNotAllowedBySize,
  imageNotAllowedByExtension
}: ICardUploadPhoto) => {
  // --------------------------------------------------------
  // LabelInput PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const { isMobile } = useResponsiveInfo();

  // --------------------------------------------------------

  // create a preview as a side effect, whenever selected file is changed

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------

  const PhotoArea = ()=>{
    if(imageNotAllowedByExtension){
      return <CardPhoto src={imageNotPermission} alt="" />
    }else if(imageNotAllowedBySize){
      return <CardPhoto src={tamanhoImagemNotPermission} alt="" />
    }else{
      return <>
      <Upload />
      <H3 color="#EF4444">Clique para carregar sua foto</H3>
      <span
        style={{
          fontFamily: "Inter",
          fontSize: "12px",
          fontWeight: 400,
        }}
      >
        SVG, PNG, JPG ou JPEG (max 3MB)
      </span>
    </>
    }
  }
  
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        
        <SCardUploadPhoto htmlFor="upLoad" isMobile={isMobile}>
          {selectedFile ? (
            <CardPhoto src={preview} alt="" />
          ) : (<PhotoArea />)}
        </SCardUploadPhoto>

        {selectedFile ? (
          <CardEditPhoto
            text="Editar (SVG, PNG, JPG. Máx 3MB)"
            htmlFor="upLoad"
          />
        ) : (
          ""
        )}
        <input
          id="upLoad"
          style={{
            display: "none",
          }}
          onChange={onChange}
          name="upLoad"
          type={"file"}
        ></input>
      </div>
    </>
  );
  // --------------------------------------------------------
};

export default CardUploadPhoto;
